// Shared by the modules that animate: the visitor's motion preference, and the end of a
// CSS transition.

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

/** True when the visitor asked for reduced motion; read at event time, so it follows changes. */
export function prefersReducedMotion() {
  return window.matchMedia(REDUCED_MOTION).matches;
}

/**
 * Calls `done` once the `property` transition of `element` ends: on its own transitionend
 * (a child's transition bubbles up too, so the target and the property are checked), or
 * after `duration` ms plus a margin if the event never comes (an interrupted or skipped
 * transition). Returns a function that cancels the wait.
 */
export function afterTransition(element, property, duration, done) {
  let timer = 0;
  const finish = () => {
    cancel();
    done();
  };
  const onEnd = (event) => {
    if (event.target === element && event.propertyName === property) finish();
  };
  const cancel = () => {
    clearTimeout(timer);
    element.removeEventListener("transitionend", onEnd);
  };
  element.addEventListener("transitionend", onEnd);
  timer = setTimeout(finish, duration + 100);
  return cancel;
}
